export default function WebsiteDomainSettings() {
    return (
        <div>
            website domain settings
        </div>
    );
};